export interface ISalesCreditRetentionRate {
  Data: any[];
  DrillData: any[];
}

// tslint:disable-next-line: interface-name
export interface IsalesCreditRetentionType {
  fpvtradenegoentityregion: string;
  pcmnemo: string;
  pclabel: string;
  y: number;
  retentionRateGrossValue: number;
  retentionrate: number;
  percentage: number;
}

export interface ISalesCreditRetentionEquivType {
  BVEquiv: number;
  RetentionEquiv: string;
  SalesCreditList: IsalesCreditRetentionType[];
}

export interface IBookValueAdjustBySales {
  FpvTradingNegoEntityRegion: string;
  SalesName: string;
  ScYtd: number;
  BvAdjust: number;
  RetentionRateEquiv: number;
}

export const AirRetentionRateKpis = {
  BV_ADJUST: "bv_adjust",
  RETENTION_RATE_EQUIV: "retention_rate_equiv",
};
